import "./FixedStamp.scss";

export default {
  root: "fixed-stamp",
  overlayLink: "fixed-stamp__overlay-link",
  imageWrapper: "fixed-stamp__image-wrapper",
  content: "fixed-stamp__content",
  overtitle: "fixed-stamp__overtitle",
  title: "fixed-stamp__title",
  subtitle: "fixed-stamp__subtitle",
};
